import React,{useState} from "react";
import Modal from "react-modal";
import { Box } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import ValueGenerationSection from './Value_Generation_Section';

const ValueGenerationModal = ({ modalIsOpen, closeModal, volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually}) => {
return (
      <>
        <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal">
          <div className="My__Overlay">
            <div className="My__OverlayIn">
              <div className="PTGCSEC popupcenter">
                <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}>
                  <span className="underline">Close</span>
                  <img src="./images/XCircle.svg" className="img-fluid" alt="Close" />
                </button>
                <div className="container">
                  <div className="text-center">
                    <h2 className="mb-4 mt-2 w-100 good_times goldFont">Value Generation</h2>
                  </div>
                  <div className="subcontent subPad SRTOP p-0">
                    <ValueGenerationSection 
                      volumeDaily={volumeDaily} 
                      volumeWeekly={volumeWeekly} 
                      volumeMonthly={volumeMonthly} 
                      volumeQuarterly={volumeQuarterly}
                      volumeSemiAnnually={volumeSemiAnnually} 
                      volumeAnnually={volumeAnnually}
                    />
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ValueGenerationModal;
